/**
 * Build-time switches read from `.env.<BUILD_TARGET>`. Fixed per deployed
 * bundle; changing one needs a rebuild. Runtime feature flags live in
 * `constants.js` and `multitenancy.js`.
 */

/**
 * Whether the MUI admin under `/admin/next` is registered.
 *
 * @returns {boolean}
 */
export function isAdminNextEnabled() {
  return process.env.REACT_APP_ADMIN_NEXT_ENABLED === 'true'
}
